import { render, staticRenderFns } from "./Attribute.vue?vue&type=template&id=b0646b40&scoped=true"
import script from "./Attribute.vue?vue&type=script&lang=js"
export * from "./Attribute.vue?vue&type=script&lang=js"
import style0 from "./Attribute.vue?vue&type=style&index=0&id=b0646b40&prod&lang=scss&scoped=true"
import style1 from "./Attribute.vue?vue&type=style&index=1&id=b0646b40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0646b40",
  null
  
)

export default component.exports